import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import BlindAssistant from './components/BlindAssistant';
import DocsPage from './components/DocsPage';
import ManualPage from './components/ManualPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="container"></div>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/app" element={<BlindAssistant />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/manual" element={<ManualPage />} />
      </Routes>
    </Router>
  );
}

export default App;